export enum DraftTypes {
    PATIENT = 0,
    CASE = 1,
    PERPERTRATOR = 2,
    INTERVENTION = 3
}
